module.exports = __webpack_public_path__ + "static/media/Overview_header.9276e174.png";